import { render } from "./SentWithdrawals.vue?vue&type=template&id=2f2b7e3c&ts=true"
import script from "./SentWithdrawals.vue?vue&type=script&lang=ts"
export * from "./SentWithdrawals.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__